import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {ColumnMode, DatatableComponent, SelectionType, SortType} from '@swimlane/ngx-datatable';
import {MbDatatablesTemplate} from "./mb-datatables-template";
import {MbActionModel, MbSort} from "./models/mb-datatable.model";

@Component({
    selector: 'app-mb-datatable',
    templateUrl: './mb-datatable.component.html',
    styleUrls: ['./mb-datatable.component.scss']
})
export class MbDatatableComponent implements OnInit, OnChanges {
    private INLINE_DETAILS_COL = {
        cellTemplate: {},
        resizeable: false,
        sortable: false,
        canAutoResize: false,
        width: 20
    };
    private ACTION_COL = {
      cellTemplate: {},
      resizeable: false,
      sortable: false,
      canAutoResize: false,
    };

    @Input() columnsTpl: any[];
    @Input() rows: any[];
    @Input() actionConfig: MbActionModel[];
    @Input() inlineDetailsTpl: TemplateRef<any>;

    @Input() sorts: MbSort[] = [new MbSort('createdAt', MbSort.DESC)];


    @ViewChild(DatatableComponent) table: DatatableComponent;
    @ViewChild('hdrTpl') hdrTpl: TemplateRef<any>;
    @ViewChild('translateTpl') translateTpl: TemplateRef<any>;
    @ViewChild('pureTranslateTpl') pureTranslateTpl: TemplateRef<any>;
    @ViewChild('datetimeTpl') datetimeTpl: TemplateRef<any>;
    @ViewChild('dateTpl') dateTpl: TemplateRef<any>;
    @ViewChild('actionsTpl') actionsTpl: TemplateRef<any>;
    @ViewChild('showDetailsTpl') showDetailsTpl: TemplateRef<any>;


    public entries = 10;
    public originalRows: any[];
    public ColumnMode = ColumnMode;
    public SortType = SortType;
    public filters = {};
    public columns: any[];


    constructor() {
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
        this.originalRows = this.rows;
        if(this.columnsTpl != undefined) {
            this.columnsTpl.forEach(column => {
                if (column.headerTemplate != undefined) {
                    column.headerTemplate = this[column.headerTemplate];
                }
                if (column.cellTemplate != undefined) {
                    column.cellTemplate = this[column.cellTemplate];
                }
            });
            if (this.inlineDetailsTpl != undefined) {
                this.INLINE_DETAILS_COL.cellTemplate = this[MbDatatablesTemplate.SHOW_DETAILS_TEMPLATE];
                this.columnsTpl.unshift(this.INLINE_DETAILS_COL);
            }

            if (this.actionConfig != undefined) {
                this.ACTION_COL.cellTemplate = this[MbDatatablesTemplate.ACTION_TEMPLATE];
                this.columnsTpl.unshift(this.ACTION_COL);
            }
            this.columns = this.columnsTpl;
            this.columnsTpl.forEach(col => {
                if (col.input != undefined && col.input.defaultValue != undefined) {
                    this.filters[col.prop] = col.input.defaultValue;
                }
            });
            this.filter();
        }
    }

    entriesChange($event) {
        this.entries = $event.target.value;
    }

    toggleExpandRow(row) {
        this.table.rowDetail.toggleExpandRow(row);
    }

    onDetailToggle(event) {
    }

    filterInput() {
        this.filter()
    }


    filter() {
        let temp = [...this.originalRows];
        Object.keys(this.filters).forEach(key => {
            if (this.filters[key].length > 0) {
                temp = temp.filter(order => {
                    const keyParts = key.split('.');
                    let filterValue = null;
                    keyParts.forEach(partOfKey => {
                        if (filterValue == null) {
                            filterValue = order[partOfKey]
                        } else {
                            filterValue = filterValue[partOfKey];
                        }
                    });
                    if(filterValue == null){return false;}
                    return filterValue.toString().toLowerCase().indexOf(this.filters[key].toLowerCase())>-1;
                });
            }
        });

        this.rows = temp;
        if(this.table) {
            this.table.offset = 0;
        }
    }

    clearAllFilter() {
        this.filters = {};
        this.filter();
    }

    clearFilter(prop: any) {
        delete this.filters[prop];
        this.filter();
    }


    isHidden(row, action:MbActionModel) {
        if(action.expression) {
            return action.expression(row);
        }
        return false;
    }
}
